import app from '@/app';

/* @ngInject */
function Resource($resource) {
	return $resource(
		'api/constanthistorics/:version/:idplan',
		{ idplan: '@idplan',
      version: '@version'},
		{
			query: { method: 'GET' }
		}
	);
}

app.factory('ConstantHistoric', Resource);



